if (!customElements.get('ib-product-gallery')) {
  customElements.define('ib-product-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = [...this.track.children];
      this.thumbs = [...this.querySelectorAll('[data-gallery-index]')];
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.request = 0;
      const prepare = (index, priority = 'low') => {
        const img = this.slides[index]?.querySelector('img');
        if (!img) return Promise.resolve();
        img.fetchPriority = priority;
        img.loading = 'eager';
        return img.decode().catch(() => {});
      };
      this.thumbs.forEach((button, index) => {
        button.addEventListener('pointerenter', () => prepare(index), {signal});
        button.addEventListener('focus', () => prepare(index), {signal});
        button.addEventListener('click', async () => {
          const request = ++this.request;
          this.setAttribute('aria-busy', 'true');
          await prepare(index, 'high');
          if (signal.aborted || request !== this.request) return;
          this.track.scrollTo({left: this.slides[index].offsetLeft - this.slides[0].offsetLeft, behavior: 'instant'});
          this.sync();
          this.removeAttribute('aria-busy');
          prepare(index + 1);
        }, {signal});
      });
      // Warm alternate views only after the main image is ready.
      const firstImage = this.slides[0]?.querySelector('img');
      firstImage?.decode().catch(() => {}).then(() => {
        if (signal.aborted) return;
        this.warmTimer = setTimeout(() => {
          if (!signal.aborted) this.slides.slice(1).forEach((_, i) => prepare(i + 1));
        }, 300);
      });
      this.slides.forEach(slide => {
        const img = slide.querySelector('img');
        if (!img) return;
        img.tabIndex = 0;
        img.setAttribute('role', 'button');
        img.setAttribute('aria-label', 'Zoom: ' + img.alt);
        img.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); img.click(); }
        }, {signal});
      });
      this.sync = () => {
        const index = Math.round(this.track.scrollLeft / Math.max(1,this.track.clientWidth));
        this.thumbs.forEach((button,i) => {
          if (i === index) button.setAttribute('aria-current','true');
          else button.removeAttribute('aria-current');
        });
        this.slides.forEach((slide,i) => { const img=slide.querySelector('img'); if(img) img.tabIndex=i===index?0:-1; });
      };
      this.track.addEventListener('scroll', this.sync, {passive:true,signal});
      this.sync();
    }
    disconnectedCallback() { this.controller?.abort(); clearTimeout(this.warmTimer); }
  });
}
